<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Button from "@/components/button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import List from "../../../components/list";
import { customerService } from "../../../services/contactservice/customer.service";
import { commissionService } from "../../../services/saleservice/commission.service";
import { propertyService } from "../../../services/propertyservice/property.service";
import { propertylatepaymentService } from "../../../services/propertyservice/propertylatepayment.service";
import { propertycancelationService } from "../../../services/propertyservice/propertycancelation.service";
import { propertyattachmentService } from "../../../services/propertyservice/propertyattachment.service";
import { bookingtransferService } from "../../../services/bookingservice/bookingtransfer.service";
import { saletransferService } from "../../../services/saleservice/saletransfer.service";
import { servicehelpers } from "../../../services/servicehelpers";
import i18n from "../../../i18n";
import Loading from "@/components/c-loading";

/**
 * Contacts-list component  
 */
export default {
  page: {
    title: "Property Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    // Button,
    Input,
    Area,
    Dropzone,
    Select,
    List
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "property",
      currency: "",
      latePaymentData: {},
      commissionData: {},
      cancelationData: {},
      transferData: {},
      saleTransferData: {},
      selectCustomer: null,
      propertyData: null,
      customerData: {},
      projectData: {},
      floorData: {},
      statusData: {},
      typeData: {},
      groupData: {},
      currencyData: {},
      breadCrumb: {},
      attachement: {},
      ownershipHistory: {},
      bookingHistory: {},
      saleHistory: {},
      paymentHistory: {},
      expenseHistory: {},

      dataCode: '',
      dataType: 0,
      dataCustomer: 0,
      dataDescription: '',
      dataNetSize: 0,
      dataGrossSize: 0,
      dataFloor: 0,
      dataProject: 0,
      dataGroup: 0,
      dataStatus: 0,
      dataCurrency: 0,
      dataPrice: 0,
      dataPhoto: [],
      dataLivingRoomNo: 0,
      dataBedRoomNo: 0,
      dataKitchenNo: 0,
      dataBathRoomNo: 0,
      dataBalconyNo: 0,

    };
      
  },
  mounted() {
    /* eslint-disable no-console */
   
    // this.loadingCommissionData();
    // this.loadingCancelationData();
    // this.loadingTransferData();
    // this.loadingTypeData();
    // this.loadingStatusData();
    // this.loadingProjectData();
    // this.loadingFloorData();
    // this.loadingCurrencyData();
    // this.loadingGroupData();
    // this.loadingCustomerData();
    // this.loadingCommissionData();
    // this.loadingCancelationData();
    // this.loadingTransferData();
  

    this.dataType = 1;
    this.dataStatus = 1;
    this.dataCurrency = 1;

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    }else{
      // Loading
          this.loadingTypeData();
          this.loadingStatusData();
          this.loadingProjectData();
          this.loadingFloorData();
          this.loadingCurrencyData();
          this.loadingGroupData();
          this.loadingCustomerData();
          this.loadingFloorData();
          this.loadingLatePaymentData();
    }
  },

  methods: {
    loadingData: function(id) {
      // console.log("AAAAAA", id);
      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          // console.log(response);

          if(response.data == null) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-add"
            });
          }



          this.breadCrumb = {
            text: response.data.code,
            active: true,
          };

          this.fetchingStats = true;
          this.propertyData = response;

          this.dataCustomer = this.propertyData.data.customer_id;

          this.dataCode = this.propertyData.data.code;
          this.dataType = this.propertyData.data.property_type_id;
          this.dataDescription = this.propertyData.data.description;

          this.dataNetSize = this.propertyData.data.net_size;
          this.dataGrossSize = this.propertyData.data.cross_size;
          this.dataFloor = this.propertyData.data.project_floor_id;
          this.dataProject = this.propertyData.data.project_id;
          this.dataGroup = this.propertyData.data.property_group_id;
          this.dataStatus = this.propertyData.data.property_status_id;
          this.dataCurrency = this.propertyData.data.currency_id;
          this.dataPrice = this.propertyData.data.price;

          this.dataLivingRoomNo = this.propertyData.data.living_room_no;
          this.dataBedRoomNo = this.propertyData.data.bed_room_no;
          this.dataKitchenNo = this.propertyData.data.kitchen_no;
          this.dataBathRoomNo = this.propertyData.data.bathroom_no;
          this.dataBalconyNo = this.propertyData.data.balcony_no;
          
          this.propertyData.data.collections.map(item => {
            if('property_attachments' in item) {
              this.dataPhoto = item.property_attachments;
            } 
          });
        

          // Loading
          // this.loadingTypeData();
          // this.loadingStatusData();
          // this.loadingProjectData();
          // this.loadingFloorData();
          // this.loadingCurrencyData();
          // this.loadingGroupData();
          // this.loadingFloorData();
          this.loadingCustomerById(this.propertyData.data.customer_id);
         
        });

    },

    loadingLatePaymentData: function() {
      this.fetchingStats = false;
      propertylatepaymentService.getList(this.$route.params.id)
        .then(response => {
          
          this.fetchingStats = true;
          this.latePaymentData = response.data;

          // console.log(this.commissionData);
        });

    },

    loadingCommissionData: function() {

      let param = `?clause={"clause":[{"conjuction":"and","commissions.property_id":{"value":${this.$route.params.id}}}]}&active=0`;

      this.fetchingStats = false;
      commissionService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.commissionData = response;

          // console.log(this.commissionData);
        });
    },

    loadingCancelationData: function() {

      let param = `?clause={"clause":[{"conjuction":"and","property_cancelations.property_id":{"value":${this.$route.params.id}}}]}`;

      this.fetchingStats = false;
      propertycancelationService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.cancelationData = response;
        });
    },

    loadingTransferData: function() { 

      let param = `?clause={"clause":[{
        "conjuction":"and",
          "booking_transfers.from_property_id":{
            "value":${this.$route.params.id}, 
            "conjuction": "or"
          }, 
          "booking_transfers.to_property_id":{
            "value":${this.$route.params.id}, 
            "conjuction": "or"
          }
        }
        ]}`;

      this.fetchingStats = false;
      bookingtransferService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.transferData = response;
        });
    },

    loadingSaleTransferData: function() { 

      let param = `?clause={"clause":[{"conjuction":"and","sale_transfers.property_id":{"value":${this.$route.params.id}}}]}`;

      this.fetchingStats = false;
      saletransferService.getList(param)
        .then(response => {
          
          // console.log(JSON.stringify(response.data));
          this.fetchingStats = true;
          this.saleTransferData = response;
        });
    },

    loadingCustomerData: function() {
      customerService.getList()
        .then(response => {
          
          this.customerData = response;
        });
    },

    loadingCustomerById: function(id) {
      customerService.getOne(id)
        .then(response => {
          // console.log(JSON.stringify(response.data));
          this.selectCustomer = response.data;
           this.loadingPropertyAttachmentByPropertyId(this.propertyData.data.id);
        });
    },

    loadingPropertyById: function(propertyId) {

      let param = propertyId == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","properties.id":{"value":${propertyId}}}]}`;

      propertyService.getList(param)
        .then(response => {
          this.propertyData = response;
        });
    },

    loadingPropertyAttachmentByPropertyId: function(propertyId) {

      let param = propertyId == 0 ? '?page=0' : `?page=0&clause={"clause":[{"conjuction":"and","property_attachments.property_id":{"value":${propertyId}}}]}`;

      propertyattachmentService.getList(param)
        .then(response => {
          this.attachement = response;
        });
    },
    

    loadingCurrencyData: function() {
      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },

    loadingTypeData: function() {
      servicehelpers.getPropertyTypeData().then(response => {
        this.typeData = response;
      });
    },

    loadingStatusData: function() {
      servicehelpers.getPropertyStatusData().then(response => {
        this.statusData = response;
      });
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projectData = response;
      });
    },

    loadingFloorData: function(projectId = 0) {
      servicehelpers.getFloorData(projectId).then(response => {
        this.floorData = response;
      });
    },

    loadingGroupData: function(projectId = 0) {
      servicehelpers.getGroupData(projectId).then(response => {
        this.groupData = response;
      });
    },

    loadingOwnershipHistory: function(propertyId = 0, param = "") {
      let uri = param ? propertyId+param : propertyId+'?page=1';
      propertyService.getHistory('ownership', uri)
        .then(response => {
          this.ownershipHistory = response;
          console.log(this.ownershipHistory)
      });
    },

    loadingBookingHistory: function(propertyId = 0, param = "") {
      let uri = param ? propertyId+param : propertyId+'?page=1';
      propertyService.getHistory('booking', uri)
        .then(response => {
          this.bookingHistory = response;
      });
    },

    loadingSaleHistory: function(propertyId = 0, param = "") {
      let uri = param ? propertyId+param : propertyId+'?page=1';
      propertyService.getHistory('sale', uri)
        .then(response => {
          this.saleHistory = response;
      });
    },

    loadingPaymentHistory: function(propertyId = 0, param = "") {
      let uri = param ? propertyId+param : propertyId+'?page=1';
      propertyService.getHistory('payment', uri)
        .then(response => {
          this.paymentHistory = response;
      });
    },

    loadingExpenseHistory: function(propertyId = 0, param = "") {
      let uri = param ? propertyId+param : propertyId+'?page=1';
      propertyService.getHistory('expense', uri)
        .then(response => {
          this.expenseHistory = response;
      });
    },

    handleSelectProject: function(id) {
      this.loadingFloorData(id);
    },

    // loading data when tabl is click 
    onHistoryClicked: function(){
      let propertyId = this.$route.params.id
      
      this.loadingOwnershipHistory(propertyId);
      // setTimeout( this.loadingBookingHistory(propertyId), 300);
      // setTimeout( this.loadingSaleHistory(propertyId), 600);
      // setTimeout( this.loadingPaymentHistory(propertyId), 900);
      // setTimeout( this.loadingExpenseHistory(propertyId), 1200);
      // this.loadingSaleHistory(propertyId);
      // this.loadingPaymentHistory(propertyId);
      // this.loadingExpenseHistory(propertyId);
    },

    onTabLatePaymentClick: function() {
      this.loadingLatePaymentData();
    },

    onTabCommissionClick: function() {
      this.loadingCommissionData();
    },

    onHistoryOwnershipClick: function(){
      let propertyId = this.$route.params.id
      this.loadingOwnershipHistory(propertyId)
    },

    onHistoryBookingClick: function(){
      let propertyId = this.$route.params.id
      this.loadingBookingHistory(propertyId)
    },

    onHistorySaleClick: function(){
      let propertyId = this.$route.params.id
      this.loadingSaleHistory(propertyId)
    },

    onHistoryPaymentClick: function(){
      let propertyId = this.$route.params.id
      this.loadingPaymentHistory(propertyId)
    },

    onHistoryExpenseClick: function(){
      let propertyId = this.$route.params.id
      this.loadingExpenseHistory(propertyId)
    },

    // onTabCommistsionClick: function(){
    //   this.loadingCommissionData();
    // },

    onTabCancellationClick: function(){
      this.loadingCancelationData();
    },

    onTabTransferClick: function(){
      this.loadingTransferData();
    },

    onTabSaleTransferClick: function(){
      this.loadingSaleTransferData();
    },

    onTabTransferHistoryClick: function(){
        this.loadingSaleTransferData();
    },

    

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
          });

        }
      });

      
    },
    submitSave: function() {
      this.tryingToSubmit = true;

      let obj = {
        parent_id: 0,
        code: this.dataCode,
        property_type_id: this.dataType,
        description: this.dataDescription,
        net_size: this.dataNetSize,
        cross_size: this.dataGrossSize,
        project_floor_id: this.dataFloor,
        project_id: this.dataProject,
        property_group_id: this.dataGroup,
        property_status_id: this.dataStatus,
        currency_id: this.dataCurrency,
        price: this.dataPrice,
        // property_attachments: this.dataPhoto,
        living_room_no: this.dataLivingRoomNo,
        bed_room_no: this.dataBedRoomNo,
        kitchen_no: this.dataKitchenNo,
        bathroom_no: this.dataBathRoomNo,
        balcony_no: this.dataBalconyNo
        
      };

      // console.log(JSON.stringify(obj));

      if(this.isAdd) {
        propertyService.insert(obj)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "property-list"
                  });
                } 
              });
           }
          
        });
      } else {
        // console.log(JSON.stringify(customer));
        propertyService.update(this.$route.params.id, obj)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "property-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });

          }
        });

      }
    },

    clearForm: function() {
      this.dataCode = '';
      this.dataType = 0;
      this.dataCustomer = 0;
      this.dataDescription = '';
      this.dataNetSize = 0;
      this.dataGrossSize = 0;
      this.dataFloor = 0;
      this.dataProject = 0;
      this.dataGroup = 0;
      this.dataStatus = 0;
      this.dataCurrency = 0;
      this.dataPrice = 0;
      this.dataPhoto = [];

      this.dataLivingRoomNo = 0;
      this.dataBedRoomNo = 0;
      this.dataKitchenNo = 0;
      this.dataBathRoomNo = 0;
      this.dataBalconyNo = 0;
    },

    currencyChanged: function(event) {

      const cur = this.currencyData.data.find(obj => {
        return obj.id === event
      });

      this.currency = cur == null ? "" : cur.name_en;
    
    }, 

 

    pageNavigateOwnershipHistory: function(param) {
      this.loadingOwnershipHistory(this.$route.params.id, param);
    },

    pageNavigateBookingHistory: function(param) {
      this.loadingBookingHistory(this.$route.params.id, param);
    },

    pageNavigateSaleHistory: function(param) {
      this.loadingSaleHistory(this.$route.params.id, param);
    },

    pageNavigatePaymentHistory: function(param) {
      this.loadingPaymentHistory(this.$route.params.id, param);
    },

    pageNavigateExpenseHistory: function(param) {
      this.loadingExpenseHistory(this.$route.params.id, param);
    },

    moreTransferClicked: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.approve'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
                
            bookingtransferService.approve(id).then(response => {
              if(response.status == 200) {
                
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.denie'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {

            bookingtransferService.denie(id).then(response => {
              if(response.status == 200) {
                
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      }
    },

    moreSaleTransferClicked: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.approve'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
                
            saletransferService.approve(id).then(response => {
              if(response.status == 200) {
                
                this.loadingSaleTransferData();
                
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.denie'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {

            saletransferService.denie(id).then(response => {
              if(response.status == 200) {
                
                this.loadingSaleTransferData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      }
    },

    moreCancelClicked: function(event, id) {
      if(event == 'approve') {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.approve'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {
                
            propertycancelationService.approve(id).then(response => {
              if(response.status == 200) {
                
                this.loadingCancelationData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      } else {
        this.$swal.fire({
          title: i18n.t('general.cancel-confirm.title'),
          text: i18n.t('property.cancelation.denie'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t('general.ok'),
          cancelButtonText: i18n.t('general.cancel')
        }).then(result => {
          if (result.value) {

            propertycancelationService.denie(id).then(response => {
              if(response.status == 200) {
                
                this.loadingCancelationData();
                this.$swal.fire({
                  title: i18n.t('general.success.title'),
                  text: i18n.t('general.success.message'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: i18n.t('general.success.yes')
                });

              }
            });

          }
        });
      }
    },
  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, {
        text: $t('property.new'),
        active: true
      }]" :title="this.isAdd ? $t('property.new') : $t('property.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('property.list'),
        href: '/general/property',
      }, this.breadCrumb]" :title="this.isAdd ? $t('property.new') : $t('property.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="p-3 text-muted">
              <b-tab active class="border-0" style="background: #fff">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-cart bx-tada font-size-20 align-middle me-2"></i>
                    {{$t('customer.general')}}
                  </div>
                </template>
                <div v-show="fetchingStats" class="row">
                  <b-form class="row">
                    <div class="col-lg-8">
                      <div class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-6">
                              <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="dataCode"
                                :label="'customer.code'" 
                                :require="true"
                              /> 
                            </div>
                            <div class="col-md-6">
                              <!-- <Select 
                                :text="'name'"
                                :id="'project_id'"
                                v-model="dataProject"
                                :list="this.projectData"
                                :label="'property.project'"
                                :require="true"
                              />  -->
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.project"
                                :label="'property.project'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <!-- <Select 
                                :id="'project_floor_id'"
                                v-model="dataFloor"
                                :text="'number'"
                                :prefix="$t('general.floor-no') + ' '"
                                :list="this.floorData"
                                :label="'property.floor'"
                                :require="true"
                              />  -->
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.floor"
                                :label="'property.floor'" 
                              /> 
                            </div>
                            <div class="col-md-6">
                              <!-- <Select 
                            :text="'name'"
                                :id="'property_group_id'"
                                v-model="dataGroup"
                                :list="this.groupData"
                                :label="'property.group'"
                                :require="true"
                              />  -->
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.group"
                                :label="'property.group'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <!-- <Select 
                            :text="'name'"
                                :id="'property_type_id'"
                                v-model="dataType"
                                :disabled="true"
                                :list="this.typeData"
                                :label="'property.type'"
                              />  -->
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.type"
                                :label="'property.type'" 
                              /> 
                            </div>
                            <div class="col-md-6">
                              <!-- <Select 
                            :text="'name'"
                                :id="'property_status_id'"
                                v-model="dataStatus"
                                :list="this.statusData"
                                :label="'property.status'"
                                :disabled="true"
                              /> -->
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.status"
                                :label="'property.status'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <Input 
                                :type="'number'"
                                :id="'price'"
                                v-model="dataPrice"
                                :last="currency"
                                :label="'property.price'" 
                                :require="true"
                              />
                            </div>
                            <div class="col-md-6">
                              <Select 
                                :text="'name'"
                                @change="currencyChanged" 
                                :id="'currency_id'"
                                :class="'d-none'"
                                v-model="dataCurrency"
                                :list="this.currencyData"
                                :label="'property.currency'"
                                :disabled="true"
                              />
                               <Input 
                                :type="'text'"
                                :id="'code'"
                                v-model="propertyData.data.currency"
                                :label="'property.currency'" 
                              /> 
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <Input 
                                :type="'number'"
                                :id="'cross_size'"
                                :last="'general.square'"
                                v-model="dataGrossSize"
                                :label="'property.gross-size'" 
                              />
                            </div>
                            <div class="col-md-6">
                              <Input 
                                :type="'number'"
                                :last="'general.square'"
                                :id="'net_size'"
                                v-model="dataNetSize"
                                :label="'property.net-size'" 
                              />
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-3">
                              <Input 
                                :type="'number'"
                                :id="'bed_room_no'"
                                v-model="dataBedRoomNo"
                                :label="'property.bed-room-no'" 
                              />
                            </div>
                            <div class="col-md-3">
                              <Input 
                                :type="'number'"
                                :id="'living_room_no'"
                                v-model="dataLivingRoomNo"
                                :label="'property.living-room-no'" 
                              />
                            </div>

                            <div class="col-md-2">
                              <Input 
                                :type="'number'"
                                :id="'kitchen_no'"
                                v-model="dataKitchenNo"
                                :label="'property.kitchen-no'" 
                              />
                            </div>
                            <div class="col-md-2">
                              <Input 
                                :type="'number'"
                                :id="'bathroom_no'"
                                v-model="dataBathRoomNo"
                                :label="'property.bathroom-no'" 
                              />
                            </div>
                            <div class="col-md-2">
                              <Input 
                                :type="'number'"
                                :id="'balcony_no'"
                                v-model="dataBalconyNo"
                                :label="'property.balcony-no'" 
                              />
                            </div>

                          </div>

                          <div class="row">
                            <div class="col-lg-12">
                              <Area 
                                :rows="7"
                                :id="'description'"
                                v-model="dataDescription"
                                :label="'property.description'"  />
                            </div>
                          </div>
                          <!-- <div class="row">
                            <div class="col-lg-12">

                              <b-form inline class="row gy-2 gx-3 align-items-end">
                                <div class="col-sm-auto">
                                  <Button v-bind:icon="'bx bx-x-circle'" 
                                    v-bind:buttonType="'button'"
                                    v-bind:variant="'danger'"
                                    @click="submitCancel()"
                                    v-bind:title="$t('general.cancel')"  />
                                </div>
                                <div class="col-sm-auto">
                                  <Button v-bind:icon="'bx bx-save bx-tada'" 
                                    v-bind:buttonType="'button'"
                                    @click="submitSave()"
                                    v-bind:requesting="tryingToSubmit"
                                    v-bind:title="$t('general.save')"  />
                                </div>
                              </b-form>
                
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-4">
                      
                      <div v-if="this.selectCustomer" class="card">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-8">
                                  <h4 class="card-title mb-4">{{$t('customer.text')}}</h4>
                                </div>
                                <!-- <div class="col-md-4">
                                  <Button v-bind:icon="'bx bx-plus-circle'" 
                                    v-bind:buttonType="'button'"
                                    v-bind:variant="'success'"
                                    @click="submitCancel()"
                                    v-bind:title="$t('general.new')"  />
                                </div> -->
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.name-en')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.name_en}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.id-type')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.idType}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.number')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.id_no}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.selectCustomer && this.selectCustomer.phone_no_2 ? this.$t('customer.phone-no-1') : this.$t('customer.phone-no')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_1}}</b></div>
                              </div>
                              <div class="row" v-show="this.selectCustomer != null && this.selectCustomer.phone_no_2">
                                <div class="col-md-4 mb-3">{{this.$t('customer.phone-no-2')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.phone_no_2}}</b></div>
                              </div>
                              <div class="row">
                                <div class="col-md-4 mb-3">{{this.$t('customer.email')}}</div>
                                <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.email}}</b></div>
                              </div>
                              <div v-show="this.selectCustomer && (this.selectCustomer.partner_name && this.selectCustomer.partner_have_to)">
                                <div class="card-title mb-3"></div>
                                <h4 class="card-title mb-3">{{$t('customer.partner-info')}}</h4>
                                <div class="row">
                                  <div class="col-md-4 mb-3">{{this.$t('customer.name')}}</div>
                                  <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_name}}</b></div>
                                </div>
                                <div class="row">
                                  <div class="col-md-4 mb-3">{{this.$t('customer.partner-type')}}</div>
                                  <div class="col-md-8 mb-3">: <b>{{this.selectCustomer == null ? '' : this.selectCustomer.partner_have_to}}</b></div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card">
                        <div class="card-body">
                          <div class="mt-3">
                            <!-- <label for="formFileDoc" class="form-label">{{$t('property.doc')}}</label>
                            <input class="form-control" type="file" id="formFileDoc" /> -->
                            <Dropzone 
                                :id="'doc'"
                                :maxFiles="5"
                                :label="'customer.doc'" 
                                @uploadSuccess="uploadDocSuccess" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </b-form>
                </div>    
              </b-tab>

              <b-tab style="background: #fff" @click="onTabCommissionClick()">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-dollar-circle font-size-20 align-middle me-2"></i>
                    {{$t('commission.text')}}
                  </div>
                </template>

                <List v-bind:dataList="commissionData" 
                    v-bind:updating="fetchingStats" 
                    v-bind:navigate="pageNavigate"
                    v-bind:formats="[{name: 'commission', type: 'currency', sign: '$'}, {name: 'commission_paid', type: 'currency', sign: '$'}]"
                    v-bind:fields="[ `code: ${$t('commission.code')}`, `name: ${$t('customer.name')}`, 
                      `sale: ${$t('sale.text')}`, `property: ${$t('property.text')}`, `seller: ${$t('seller.text')}`,
                      `commission: ${$t('commission.commission-amount')}`, `commission_paid: ${$t('commission.commission-paid')}`
                    ]" 
                    v-bind:view="{link: 'customer-view'}"
                    v-bind:more="{
                      sub: [{
                        name: 'invoice.print', icon: 'bx bx-printer', link: 'invoice-request', column: 'id', target: '_blank'
                      },{
                        name: 'commission.paid', icon: 'bx bx-list-check', link: 'commission-paid', column: 'id'
                      }] 
                    }"
                    
                    v-bind:filter="{}"
                    
                />      
              
              </b-tab>

              <b-tab style="background: #fff" @click="onTabCancellationClick()">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-block font-size-20 align-middle me-2"></i>
                    {{$t('property.cancelation.text')}}
                  </div>
                </template>

                <List v-bind:dataList="cancelationData" 
                    v-bind:updating="fetchingStats" 
                    v-bind:navigate="pageNavigate"
                    v-bind:formats="[{name: 'total', type: 'currency', sign: '$'}, {name: 'refund_amount', type: 'currency', sign: '$'}, 
                    {name: 'status', color: true}, {name: 'for_date', type: 'date'}]"
                    v-bind:fields="[ `for_date: ${$t('property.cancelation.date')}`,
                    `property: ${$t('property.text')}`, `booking: ${$t('property.cancelation.booking')}`, 
                      `sale: ${$t('property.cancelation.sale')}`, `status: ${$t('property.status')}`, 
                      `total: ${$t('property.cancelation.total')}`, `refund_amount: ${$t('property.cancelation.refund')}`,
                      `notation: ${$t('property.cancelation.notation')}`
                    ]" 
                    @more="moreCancelClicked"
                    v-bind:more="{
                      sub: [{
                        name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'property_cancelation_status_id', value: 1}
                      },{
                        name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'property_cancelation_status_id', value: 1}
                      },{
                        name: 'property.contract', icon: 'bx bx-file', link: 'property-cancellation-contract', column: 'id', target: '_blank' //show: {column: 'property_cancelation_status_id', value: 1}, 
                      }] 
                    }"
                    
                    v-bind:filter="{}"
                />      
              
              </b-tab>

              <b-tab style="background: #fff"  @click="onTabTransferClick()">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-sync font-size-20 align-middle me-2"></i>
                    {{$t('booking.transfer-property.text')}}
                  </div>
                </template>

                <List v-bind:dataList="transferData" 
                    v-bind:updating="fetchingStats" 
                    v-bind:navigate="pageNavigate"
                    v-bind:formats="[{name: 'booking_amount', type: 'currency', sign: '$'}, {name: 'status', color: true}, {name: 'for_date', type: 'date'}]"
                    v-bind:fields="[ `for_date: ${$t('property.cancelation.date')}`,
                      `booking: ${$t('property.cancelation.booking')}`, 
                      `from_property: ${$t('booking.transfer-property.from')}`, 
                      `to_property: ${$t('booking.transfer-property.to')}`, 
                      `booking_amount: ${$t('property.cancelation.total')}`,
                      `notation: ${$t('property.cancelation.notation')}`,
                      `status: ${$t('property.status')}`
                    ]" 
                    @more="moreTransferClicked"
                    v-bind:more="{
                      sub: [{
                        name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'booking_transfer_status_id', value: 1}
                      },{
                        name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'booking_transfer_status_id', value: 1}
                      },{
                        name: 'property.contract', icon: 'bx bx-file', link: 'property-cancellation-contract', column: 'id', show: {column: 'booking_transfer_status_id', value: 1}, target: '_blank'
                      }] 
                    }"
                    
                    v-bind:filter="{}"
                />      
              
              </b-tab>

              
              <b-tab style="background: #fff"  @click="onHistoryClicked(3)">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-time-five font-size-20 align-middle me-2"></i>
                    {{$t('property.history')}}
                  </div>
                </template>

                <div class="row">
                  <div class="col-sm-12">
                    <b-tabs content-class="p-3 text-muted">
                      <b-tab active class="border-0" style="background: #fff" @click="onHistoryOwnershipClick(3)">
                        <template v-slot:title>
                          <div class="btn-block">
                            <i class="bx bx-user font-size-20 align-middle me-2"></i>
                            {{$t('property.ownership')}}
                          </div>
                        </template>
                        <div v-show="fetchingStats" class="row">
                          <List v-bind:dataList="ownershipHistory" 
                            v-bind:updating="fetchingStats" 
                            v-bind:navigate="pageNavigateOwnershipHistory"
                            v-bind:fill="false"
                            v-bind:formats="[
                              {name: 'transaction_date', type: 'date'},
                            ]"
                            v-bind:fields="[ 
                              `customer_name: ${$t('customer.name')}`, 
                              `gender: ${$t('customer.gender')}`, 
                              `transaction_date: ${$t('report.income_expense.date')}`,
                            ]" 
                            v-bind:filter="{}"
                          />   
                        </div>    
                      </b-tab>

                      <b-tab class="border-0" style="background: #fff" @click="onHistoryBookingClick(3)">
                        <template v-slot:title>
                          <div class="btn-block">
                            <i class="bx bx-bookmark font-size-20 align-middle me-2"></i>
                            {{$t('booking.text')}}
                          </div>
                        </template>
                        <div v-show="fetchingStats" class="row">
                            <List v-bind:dataList="bookingHistory" 
                              v-bind:updating="fetchingStats" 
                              v-bind:navigate="pageNavigateBookingHistory"
                              v-bind:fill="false"
                              v-bind:formats="[
                                {name: 'transaction_date', type: 'date'},
                                {name: 'currency_name_en'},
                                {name: 'amount', type: 'currency'}
                              ]"
                              v-bind:fields="[ 
                                `invoice_code: ${$t('booking.code')}`, 
                                `customer_name: ${$t('customer.name')}`, 
                                `transaction_date: ${$t('report.income_expense.date')}`,
                                `currency_name_en: ${$t('property.currency')}`,
                                `amount: ${$t('booking.amount')}`,
                              ]" 
                              v-bind:filter="{}"
                            />   
                        </div>    
                      </b-tab>

                      <b-tab class="border-0" style="background: #fff" @click="onHistorySaleClick(3)">
                        <template v-slot:title>
                          <div class="btn-block">
                            <i class="bx bx-dollar font-size-20 align-middle me-2"></i>
                            {{$t('sale.text')}}
                          </div>
                        </template>
                        <div v-show="fetchingStats" class="row">
                          <List v-bind:dataList="saleHistory" 
                            v-bind:updating="fetchingStats" 
                            v-bind:navigate="pageNavigateSaleHistory"
                            v-bind:fill="false"
                            v-bind:formats="[
                              {name: 'transaction_date', type: 'date'},
                              {name: 'amount', type: 'currency'},
                              {name: 'currency_name_en'}
                            ]"
                            v-bind:fields="[ 
                              `invoice_code: ${$t('sale.code')}`, 
                              `customer_name: ${$t('customer.name')}`, 
                              `transaction_date: ${$t('report.income_expense.date')}`,
                              `currency_name_en: ${$t('property.currency')}`,
                              `amount: ${$t('sale.amount')}`,
                              
                            ]" 
                            v-bind:filter="{}"
                          />   
                        </div>    
                      </b-tab>

                      <b-tab class="border-0" style="background: #fff" @click="onHistoryExpenseClick(3)">
                        <template v-slot:title>
                          <div class="btn-block">
                            <i class="bx bx-money font-size-20 align-middle me-2"></i>
                            {{$t('expense.text')}}
                          </div>
                        </template>
                        <div v-show="fetchingStats" class="row">
                          <List v-bind:dataList="expenseHistory" 
                            v-bind:updating="fetchingStats" 
                            v-bind:navigate="pageNavigateExpenseHistory"
                            v-bind:fill="false"
                            v-bind:formats="[
                              {name: 'transaction_date', type: 'date'},
                              {name: 'amount', type: 'currency'},
                              {name: 'currency_name_en'}
                            ]"
                            v-bind:fields="[ 
                              `invoice_code: ${$t('expense.ref_no')}`, 
                              `transaction_date: ${$t('report.income_expense.date')}`,
                              `currency_name_en: ${$t('property.currency')}`,
                              `amount: ${$t('sale.amount')}`,

                            ]" 
                            v-bind:filter="{}"
                          />  
                        </div>    
                      </b-tab>

                      <b-tab class="border-0" style="background: #fff" @click="onHistoryPaymentClick(3)">
                        <template v-slot:title>
                          <div class="btn-block">
                            <i class="bx bx-table font-size-20 align-middle me-2"></i>
                            {{$t('payment.text')}}
                          </div>
                        </template>
                        <div v-show="fetchingStats" class="row">
                          <List v-bind:dataList="paymentHistory" 
                            v-bind:updating="fetchingStats" 
                            v-bind:navigate="pageNavigatePaymentHistory"
                            v-bind:fill="false"
                            v-bind:formats="[
                              {name: 'transaction_date', type: 'date'},
                              {name: 'currency_name_en'},
                              {name: 'paid', type: 'currency'},
                              {name: 'penalty', type: 'currency'},
                              {name: 'total_pay', type: 'currency'}
                            ]"
                            v-bind:fields="[ 
                              `invoice_code: ${$t('payment.code')}`, 
                              `transaction_date: ${$t('payment.date')}`,
                              `currency_name_en: ${$t('payment.currency')}`,
                              `paid: ${$t('payment.paid')}`,
                              `penalty: ${$t('payment.penalty')}`,
                              `total_pay: ${$t('payment.total_pay')}`,
                              `bank_account_name: ${$t('payment.bank_account')}`,
                              `payment_method_name_en: ${$t('payment.payment-method')}`,
                            ]" 
                            v-bind:filter="{}"
                          />   
                        </div>    
                      </b-tab>

                      

                    </b-tabs>
                  </div>
                </div>
              </b-tab>

              <b-tab active class="border-0" style="background: #fff">
                <template v-slot:title>
                  <div class="btn-block">
                    <i class="bx bx-file-blank font-size-20 align-middle me-2"></i>
                    {{$t('property.document')}}
                  </div>
                </template>
                <div class="row">
                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="report-title mb-4">
                          <i class="bx bx-time font-size-20 align-middle me-2"></i>
                          {{$t('property.late-payment')}}
                        </h4>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment1/kh/${this.$route.params.id}`">{{$t('property.late-payment-1')}}</router-link></div>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment2/kh/${this.$route.params.id}`">{{$t('property.late-payment-2')}}</router-link></div>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment3/kh/${this.$route.params.id}`">{{$t('property.late-payment-3')}}</router-link></div>
                        <div class="card-text mb-2" style="color: white">report</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="report-title mb-4">
                          <i class="bx bx-time font-size-20 align-middle me-2"></i>
                          {{$t('property.late-payment-en')}}
                        </h4>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment1/en/${this.$route.params.id}`">{{$t('property.late-payment-en-1')}}</router-link></div>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment2/en/${this.$route.params.id}`">{{$t('property.late-payment-en-2')}}</router-link></div>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment3/en/${this.$route.params.id}`">{{$t('property.late-payment-en-3')}}</router-link></div>
                        <div class="card-text mb-2" style="color: white">report</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="report-title mb-4">
                          <i class="bx bx-time font-size-20 align-middle me-2"></i>
                          {{$t('property.late-payment-cn')}}
                        </h4>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment1/cn/${this.$route.params.id}`">{{$t('property.late-payment-cn-1')}}</router-link></div>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment2/cn/${this.$route.params.id}`">{{$t('property.late-payment-cn-2')}}</router-link></div>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment3/cn/${this.$route.params.id}`">{{$t('property.late-payment-cn-3')}}</router-link></div>
                        <div class="card-text mb-2" style="color: white">report</div>
                      </div>
                    </div>
                  </div>
                  
                </div>  

                <div class="row">
                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="report-title mb-4">
                          <i class="bx bx-minus-circle font-size-20 align-middle me-2"></i>
                          {{$t('property.dissolve')}}
                        </h4>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment4/kh/${this.$route.params.id}`">{{$t('property.dissolve-km')}}</router-link></div>
                        <div class="card-text mb-2" style="color: white">report</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="report-title mb-4">
                          <i class="bx bx-minus-circle font-size-20 align-middle me-2"></i>
                          {{$t('property.dissolve')}}
                        </h4>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment4/en/${this.$route.params.id}`">{{$t('property.dissolve-en')}}</router-link></div>
                        <div class="card-text mb-2" style="color: white">report</div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-4">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="report-title mb-4">
                          <i class="bx bx-minus-circle font-size-20 align-middle me-2"></i>
                          {{$t('property.dissolve')}}
                        </h4>
                        <div class="card-text mb-2"><router-link :to="`/general/properties/late-payment4/cn/${this.$route.params.id}`">{{$t('property.dissolve-cn')}}</router-link></div>
                        <div class="card-text mb-2" style="color: white">report</div>
                      </div>
                    </div>
                  </div>
                  
                </div>    
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>